import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import AttendanceDialogTable from "./AttendanceDialogTable.vue";
import OverworkDialogTable from "./OverworkDialogTable.vue";
import ShiftDialogTable from "./ShiftDialogTable.vue";
import VacationDialogTable from "./VacationDialogTable.vue";

type Props = {
  value: boolean;
  shiftId: string;
};
type Emits = {
  (e: "input", value: boolean): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftDialog',
  props: {
    value: { type: Boolean },
    shiftId: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  shiftId: string;
};

const items = [
  { text: "休暇", component: VacationDialogTable },
  { text: "シフト", component: ShiftDialogTable },
  { text: "残業", component: OverworkDialogTable },
  { text: "勤務時間変更", component: AttendanceDialogTable }
] as const;




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const tab = ref(0);

const onClose = () => {
  modelValue.value = false;
};

return { __sfc: true,items, props, emits, modelValue, tab, onClose }
}

})